import SyncOrdersStep from './components/WelcomeContent/components/SyncOrdersStep';
import WelcomeStep from './components/WelcomeContent/components/WelcomeStep';

export const welcomeConfig = [
  {
    step: 1,
    stepName: 'Welcome',
    title: '',
    description: [] as React.ReactNode[],
    component: <WelcomeStep />,
  },
  {
    step: 2,
    stepName: 'Sync orders',
    title: 'How far back would you like to sync your orders?',
    description: [] as React.ReactNode[],
    component: <SyncOrdersStep />,
  },
];
